<template>
  <PublicLogo color-mode="dark" />
</template>
